import { has } from "lodash"

export const setAttributeAtFieldLevel = (model,attribute,newValues) => {
    model.sections.forEach((section) => {
        if (section.layout) {
            section.fields.forEach((field) => {if(has(newValues, field.id)) field[attribute] = newValues[field.id]})
        } else {
        section.fields.forEach((detail) => {
            detail.columnDefs.forEach((innerField) => {if(has(newValues, innerField.field)) innerField[attribute] = newValues[innerField.field]})
        })
        }
    })
}

export const setAttributeAtDetailLevel = (model,attribute,newValues) => {
    model.sections.forEach((section) => {
        if (section.layout === undefined) {
            section.fields.forEach((detail) => {
                if(has(newValues,detail.id)) detail[attribute] = newValues[detail.id]
            })        
        } 
    })
}

export const setSingleAttributeToAllDetails = (model,attribute,newValue) => {
    model.sections.forEach((section) => {
        if (section.layout === undefined) {
            section.fields.forEach((detail) => {
                detail[attribute] = newValue
            })        
        } 
    })
}